export const SP_LISTS = {
  TIME_ENTRIES: 'Time Entries',
  ASSET_TIMESHEETS: 'Asset Timesheets',
  PEOPLE: 'PEOPLE',
  PROJECTS: 'PROJECTS',
  BANK_HOLIDAYS: 'Bank Holidays',
  ASSETS: 'ASSETS',
  ASSET_TIMESHEET_PERMITTED_GROUP: 'Asset Timesheet Permitted Group',
  UNLOCK_TIMESHEET_PERMITTED_GROUP: 'Unlock Timesheet Permitted Group',
  COST_RATES: 'COST RATES',
  BILL_OUT_RATES: 'BILL OUT RATES',
  ARCHIVE_TIME_ENTRIES: 'ARCHIVE TIME ENTRIES',
  WORKFLOW_TRIGGERS: 'WORKFLOW TRIGGERS',
  CHASE_NOTIFICATIONS: 'Chase Notifications',
  TIMESHEET_UNLOCK_AUDIT: 'Timesheet Unlock Audit',
  // Master / lookup lists (provide dropdown options; values stored as text)
  ROLES: 'ROLES',
  COST_TYPES: 'COST TYPES',
  PROJECT_TYPES: 'PROJECT TYPES',
  COST_CENTRES: 'Cost Centres',
  PROJECT_STATUSES: 'PROJECT STATUS',
  TIMESHEET_STATUSES: 'TIMESHEET STATUSES',
  LINE_MANAGERS: 'Line Managers',
  BACKUP_APPROVERS: 'Backup Approvers',
  SUPER_APPROVERS: 'Super Approvers',
  ERROR_LOGS: 'Error Logs',
  // Ordering lists
  ORDERS: 'ORDERS',
  ORDER_LINE_ITEMS: 'ORDER LINE ITEMS',
  ORDER_APPROVAL_LOG: 'ORDER APPROVAL LOG',
  ORDER_COMMENTS: 'ORDER COMMENTS',
  COSHH_REGISTER: 'COSHH Register',
  UNIT_OF_MEASURES: 'Unit Of Measures',
  // Security/access configuration list
  SECURITY_CONFIGURATIONS: 'Security Configurations',
  // Ordering document library (files stored per-order in sub-folders named by orderRef)
  ORDER_ATTACHMENTS: 'Order Attachments',
  // Order workflow triggers (Power Automate monitors for new items and sends emails)
  ORDER_WORKFLOW_TRIGGERS: 'ORDERS WORKFLOW TRIGGERS',
  // Order Management Group membership list (Text column: PersonEmail)
  ORDER_MGMT_GROUP: 'Order Management Group',
} as const;

/** Self-approval limit (£) — non-chemical orders at or below this value self-approve. Chemical orders always require approvals. */
export const ORDER_SELF_APPROVAL_LIMIT = 250;
/** Orders at or above this value require both CEO (on-behalf-of) and CFO approval. */
export const ORDER_CEO_CFO_THRESHOLD = 10_000;

export const VALIDATION = {
  MIN_HOURS_INCREMENT: 0.15,
  MAX_DAILY_HOURS: 13,
  MAX_DAILY_ASSET_HOURS: 24,
  OOM_WARNING_THRESHOLD: 7.5,
  BANK_HOLIDAY_DEFAULT_HOURS: 7.5,
  MIN_REJECTION_REASON_LENGTH: 10,
  MIN_UNLOCK_REASON_LENGTH: 10,
} as const;

export const RETRY = {
  MAX_ATTEMPTS: 3,
  INITIAL_DELAY_MS: 2000,
  BACKOFF_FACTOR: 2,
} as const;

/** Max concurrent in-flight SharePoint requests per batch save. */
export const BATCH_CONCURRENCY = 5;

/** SharePoint list item query page size (safe below 5K threshold). */
export const SP_PAGE_SIZE = 5000;

export const BANK_HOLIDAY_PROJECT_CODE = 'NON-WORKING';

/** Days before project end date to start showing warnings in the grid. */
export const PROJECT_END_WARNING_DAYS = 14;

/** Soft launch: bypass line-manager approval step. Set enabled = false to restore normal workflow. */
export const SOFT_LAUNCH = {
  enabled: true,
  superApprovers: ['sophie.franey@evove.tech', 'coreshare@evove.tech', 'devops@coreshare.co.uk', 'ivycada@coreshare.co.uk'],
  /** Direct approver for soft launch — submissions go here instead of the line manager. */
  approverEmail: 'sophie.franey@evove.tech',
  approverName: 'Sophie Franey',
} as const;
